/**
  メニューリスト
*/
<template>
  <v-ons-page>
    <v-ons-toolbar  style="height:50px;">
        <div class="left">
           <v-ons-button modifier="quiet" @click="SetMenuListPageVisible(false)">
             <v-ons-icon icon="fa-times"></v-ons-icon> {{ localizeLabel("Common", "close")}}</v-ons-button>
        </div>
        <div class="center">
          <h1 class="page_header_title">
            {{ localizeLabel("Menulist", "title")}}
          </h1>
          </div>
        <div class="right"> </div>
    </v-ons-toolbar>
    <div class="content">
      <div class="menu_page_list">
        <div v-for="(page, index) in WPMenuList" :key="index" :data-id="page.page_id">
          <h3 v-if="page.page_category!='' && currentLangCode=='ja'" class="list_header">{{page.page_category_name}}</h3>
          <h3 v-if="page.page_category_en!='' && currentLangCode=='en'" class="list_header">{{page.page_category_name_en}}</h3>
          <h3 v-if="page.page_category_ch!='' && currentLangCode=='ch'" class="list_header">{{page.page_category_name_ch}}</h3>
          <div class="menu_page_list--item" :class="{home:page.page_id=='menu_top'}" @click="handleClickLink(page)" ><p style="margin:0">{{page.page_name}}</p><v-ons-icon class="caret" icon="fa-caret-right" style="font-size:16px"></v-ons-icon></div>
        </div>
      </div>
    </div>
  </v-ons-page>
</template>

<script>
import Toolbar from "../components/msToolbar";
import { mapGetters, mapActions } from "vuex";

export default {
  props:{
    listData: { type: Array, default: [] }
  },
  name: "MenuList",
  data() {
    return {
      refresh:true,
     }
  },
  created: function() {
    
  },
  computed: {
    ...mapGetters([
      "localizeLabel",
      'currentLangCode',
      'WPMenuList',
      ]),
  },
  methods: {
    ...mapActions([
      'SetMenuListPageVisible',
      'showErrorMessage',
      'navigateLink',
      'SetMenuListPageVisible',
    ]),
    handleClickLink(item){
      this.SetMenuListPageVisible(false)
      this.navigateLink({item:item})
    },
  },
  
  components: {
    "ms-toolbar": Toolbar,
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";

.content{
  //padding: 20px 0px 90px;
  //background-color: #111!important;
  background: $background-image-path!important;
  background-size: cover!important;
  color: $base-font-color;
}
ons-toolbar{
    //background: black;
    background: $header-bg;
    color: $header-font-color;
    border-bottom: 1px solid gray;

    ons-button{
      color: $header-font-color!important;
    }
  }

.menu_page_list{
  padding: 10px 0;
}
.menu_page_list--item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 10px;
  border-radius: 3px;
  background: $list-row-color;
  color: $list-font-color;
  padding: 10px 20px;

  &.home{
    //background: #E65407;
    background: $tab-base-bg-color;
    color: $tab-font-color;
  }
}
.list_header{
  text-align: left;
  padding: 0 25px;
  font-size: 16px;
  
}
/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/MenuListPage.vue